<template>
  <div class="gc-start-screen">
    <gc-button
      class="gc-start-screen__button"
      color="primary"
      block
      large
      @click="startAssistant()"
    >
      <span>{{ $t('start.buttonText') }}</span>
      <font-awesome-icon :icon="faAngleRight" class="gc-ml-2" />
    </gc-button>

    <v-container
      v-if="showDeviceChangeQrCode"
      class="mt-5"
      :class="isMd ? '' : 'd-none'"
    >
      <v-row justify="center">
        <p class="gc-text-sm gc-text-gray-400 mb-5">
          {{ $t('start.switchToMobile') }}
        </p>
      </v-row>
      <v-row justify="center">
        <qr-code :text="baseUrl"></qr-code>
      </v-row>
    </v-container>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons';
import GcButton from '@/components/primitives/GcButton.vue';
import RestoreAlert from '@/components/RestoreAlert.vue';
import { useResponsiveBreakpoints } from '@/lib/ui-helper/responsive';
export default defineComponent({
  components: {
    GcButton,
    RestoreAlert,
  },
  setup: (_, { emit }) => {
    const startAssistant = () => {
      emit('start');
    };

    const baseUrl = process.env.VUE_APP_BASE_URL;

    const showDeviceChangeQrCode =
      process.env.VUE_APP_SHOW_DEVICE_CHANGE_QR_CODE === 'true';

    const { isMd } = useResponsiveBreakpoints();

    return {
      baseUrl,
      isMd,
      showDeviceChangeQrCode,
      faAngleRight,
      startAssistant,
    };
  },
});
</script>

<style lang="scss">
.gc-start-screen {
  position: relative;
}

.gc-start-screen__background-image,
.gc-start-screen__overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
}

.gc-start-screen__overlay {
  z-index: 2;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
}

.gc-start-screen__content {
  position: relative;
  z-index: 2000;
}
</style>
